<label *ngIf="label" class="rich-text-label">{{ label }}</label>
<div #editor></div>
<custom-context-menu [editorMenuElement]="menuElement"></custom-context-menu>
